import { Component } from '@angular/core';

@Component({
  selector: 'wsb-email-history',
  templateUrl: './email-history.component.html',
  styleUrls: ['./email-history.component.scss'],
  standalone: false
})
export class EmailListComponent {
  activeId = 1;

  constructor() {}
}
